import React from "react";
import Skimmer from "../../core/components/Skimmer";
import { Img } from "../../core/design-system/Img";

interface AccountSkimmerProps {
  // Define your prop types here
}

const AccountSkimmer: React.FC<AccountSkimmerProps> = (props) => {
  const tableData = [
    {
      payee: "Mr. Bones",
      refNo: "879024865902",
      date: "3/4/24, 10:32 AM",
      type: "credit",
      amount: "AED 31,925",
    },
  ];
  return (
    <div className="flex flex-col w-full gap-10 justify-around">
      {/* Header */}

      <div className="flex flex-row justify-between h-[223px] bg-red-500">
        <div className="flex pt-10 pb-3 px-5">
          <div className="flex flex-col justify-between w-full items-start gap-14">
            <Skimmer width="w-80" height="h-40" />

            <div className="flex flex-row gap-60 w-full ">
              <div className="flex flex-col  items-start justify-end">
                <Skimmer width="w-40" height="h-20" />
                <Skimmer width="w-60" height="h-30" />
              </div>

              <div className="flex flex-row gap-10 items-start px-4 py-3 rounded-lg bg-orange">
                <div className="flex flex-col  items-start">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-10" />
                </div>
                <div className="flex flex-col items-start">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-10" />
                </div>
                <div className="flex flex-col items-start">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-10" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Img
          src={"images/pngwing.png"}
          alt="Account"
          className="w-[500px] h-full object-cover"
        />
      </div>

      <div className="flex flex-row w-full p-4 gap-5">
        <div className="flex flex-col w-3/4">
          {/* table */}

          <div className="border border-lightGray bg-white-A700 rounded-lg shadow-sm overflow-hidden">
            <div className="flex flex-row justify-between items-center px-[24px] py-[20px]">
              <p className=" font-semibold text-[18px]">Latest Transactions</p>

              <Skimmer width="w-40" height="h-10" />
            </div>
            <table className="table-auto w-full">
              <thead>
                <tr>
                  {Object.keys(tableData[0]).map((key, index) => (
                    <th
                      key={"table_head_" + index}
                      className="px-4 py-2 text-[12px] border-lightGray font-medium align-middle text-center border border-x-0 "
                    >
                      {key.replace(/^\w/, (c) => c.toUpperCase())}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[0, 1, 2, 3, 4].map((data, index) => (
                  <tr key={"table_row_" + index}>
                    <td
                      key={"table_data_" + index}
                      className="border border-x-0  border-t-0 border-lightGray px-4 py-2 "
                    >
                      <div className="flex flex-row items-center gap-2 px-[24px] py-[16px]">
                        <Skimmer width="w-10" height="h-10" type="circle" />
                        <Skimmer width="w-40" height="h-10" />
                      </div>
                    </td>

                    <td
                      key={"table_data_" + index}
                      className="border border-x-0  border-t-0 border-lightGray px-4 py-2 "
                    >
                      <Skimmer width="w-20" height="h-10" />
                    </td>

                    <td
                      key={"table_data_" + index}
                      className="border border-x-0 border-t-0 border-lightGray px-4 py-2 "
                    >
                      <div className="flex flex-row items-center gap-2 px-[24px] py-[16px]">
                        <Skimmer width="w-20" height="h-10" />
                      </div>
                    </td>

                    <td
                      key={"table_data_" + index}
                      className="border border-x-0  border-t-0 border-lightGray px-4 py-2 "
                    >
                      <div className="flex flex-row items-center gap-2 px-[24px] py-[16px]">
                        <Skimmer width="w-20" height="h-10" />
                      </div>
                    </td>

                    <td
                      key={"table_data_" + index}
                      className="border border-x-0  border-t-0 border-lightGray px-4 py-2 "
                    >
                      <Skimmer width="w-20" height="h-10" />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className="flex w flex-col bg-gray-200 w-1/4">
          <div className="flex flex-col bg-gray p-4 rounded-lg w-100 border border-lightGray bg-gray-100_01 h-full">
            <div className="flex flex-col gap-8 bg-white p-3 rounded-lg bg-white-A700">
              <div className="flex flex-col mb-3">
                <p className="text-[18px] font-medium text-left">
                  Fund Transfer
                </p>
                <p className="text-[13px] text-blue_gray-500 text-left ">
                  Enter payee name or select payee to transfer amount
                </p>
              </div>

              <form className="flex flex-col gap-6">
                <div className="flex flex-col mb-4">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-5" />
                </div>

                <div className="flex flex-col mb-4">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-5" />
                </div>

                <div className="flex flex-col mb-4">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-5" />
                </div>

                <div className="flex flex-col mb-4">
                  <Skimmer width="w-20" height="h-5" />
                  <Skimmer width="w-40" height="h-10" />
                </div>

                <Skimmer width="w-20" height="h-10" />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSkimmer;
